/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Pending_StaleInputs */

const vi_einvoice_pending_stale = /** @type {(inputs: Einvoice_Pending_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nháp này có thể đã cũ so với đơn.`)
};

/**

* @param {Einvoice_Pending_StaleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_pending_stale = /** @type {((inputs?: Einvoice_Pending_StaleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Pending_StaleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_pending_stale(inputs)
});